import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { AuthService } from '../auth/service/auth.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userProfileForm! : FormGroup;
  profileImageURL: any;
  selectedFile: ImageSnippet | null = null;
  user:any;
  userId:any;
  submitted = false;
  
  constructor(
    private uploadService : UploadService,
    private fb: FormBuilder,
    private sharedDataService : SharedDataService,
    private authService: AuthService,
    private userService: UserService,
  ){}

  ngOnInit(){
    this.userProfileForm = this.fb.group({
      name: [''],
      email: [''], 
      profileImageURL: [''], 
    });
    this.getUser();
  }

  getUser(){
    this.sharedDataService.getUser().subscribe((data)=>{
      if(data){
        this.user = data;
        this.userId = data.id;
       this.userProfileForm.patchValue({
        ...data
       })
       this.profileImageURL = data.profileImageURL;
      }
    })
  }

    processFile(imageInput: any) {
      imageProcessing(imageInput).subscribe({
        next: (result) => {
          this.selectedFile = result.file;
          if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
            console.error('Invalid file selected.');
            return;
          }
          this.uploadService.uploadImageToServer(this.selectedFile).subscribe({
            next: (uploadResult: any) => {
              if (uploadResult?.fileUrl) {
                this.userProfileForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.sharedDataService.saveUser({...this.user, profileImageURL: uploadResult.fileUrl});

                this.profileImageURL = uploadResult.fileUrl
                this.onSave(this.profileImageURL)
              }
            },
            error: (uploadError) => {
              console.error('Error uploading image:', uploadError);
            },
          });
        },
        error: (processingError) => {
          console.error('Error processing image:', processingError);
        },
      });
    }

    onSave(imageUrl:any) {
    const payload = {
      profileImageURL: imageUrl,
    };
    this.userService.saveUser(this.userId,payload).pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          this.sharedDataService.saveUser(data);
        }
      },
    );
  }

    get form(){
      return this.userProfileForm.controls;
    }

  resetPassword() {
    this.authService.updatePassword({ email: this.userProfileForm.value.email }).subscribe(
      (response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {
          console.log("Response:", response);
          if (response.status === 204) {
            sweetAlert("Success", "Email sent successfully!", "success", "OK");
          } else {
            sweetAlert("Info", "Unexpected response received", "info", "OK");
          }
        }
      },
      (err) => {
        sweetAlert("Error", err.message || "Something went wrong", "error", "OK");
      }
    );
  }

}
